<div class="ticket-card-list">
  <div class="ticket-card-list-header">
    <div class="ticket-card-list-header-row">
      <div class="ticket-card-list-header-row-title">
        <span>{{ 'ticketCardList_Title_Caption' | xsI18n }}</span>
      </div>
      <mat-select
        class="ticket-card-list-filter-mat-select"
        [(value)]="currentFilter"
        (selectionChange)="setCurrentFilter($event.value)"
        sa-mat-select-backdrop-click-handler
        disableOptionCentering
      >
        <mat-option *ngFor="let currentFilter of getSelectOptions()" [value]="currentFilter.id">
          {{ currentFilter.caption }}
        </mat-option>
      </mat-select>
    </div>
  </div>
  <div class="ticket-card-list-body" sa-fill fill-padding="10">
    <ul class="ticket-card-list-list" *ngIf="loadedTickets">
      <div
        class="ticket-card-list-item"
        *ngFor="let ticket of loadedTickets"
        [ngClass]="{ 'ticket-card-list-item-Active': isTicketSelected(ticket) }"
      >
        <span class="ticket-card-list-item-selector"></span>
        <ssp-ticket-card [ticket]="ticket" [isSelected]="isTicketSelected(ticket)"> </ssp-ticket-card>
      </div>
    </ul>
  </div>

  <div class="ticket-card-list-pager" *ngIf="showPager()">
    <div class="hd-icon hd-icon-chevron-left" [class.disabled]="pageIndex === 0" (click)="decrementPage()"></div>
    <div class="ticket-card-list-pager-label">
      {{ getPageLabel() }}
    </div>
    <div class="hd-icon hd-icon-chevron-right" [class.disabled]="(this.pageIndex + 1) * this.pageSize > this.totalTickets" (click)="incrementPage()"></div>
  </div>

  <div class="ticket-card-list-footer ticket-card-list-report-incident" *ngIf="canCreateTickets">
    <a [routerLink]="['/home/create']" class="ticket-card-list-create-button">
      <div class="hd-icon hd-icon-addnew"></div>
      <div class="ticket-card-list-report-incident-label">
        {{ 'ticketList_Report_New_Incident' | xsI18n }}
      </div>
    </a>
  </div>
</div>
